var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['uw-menu-item', _vm.isActive ? 'is-active' : '' ],on:{"click":function($event){return _vm.onClick()}}},[_vm._t("default",function(){return [(_vm.showIcon && _vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.showTitle && _vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }